import styled, { css } from 'styled-components';

export const Articles = styled.section`
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: calc(-30px / 2);
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            flex-direction: column;
          }
        `
      );
    }}
    .card {
      border-radius: calc(30px / 2);
      box-shadow: 0px 3px 6px #00000029;
      box-sizing: border-box;
      margin: calc(30px / 2);
      padding: 20px;
      transition: 0.3s;
      width: calc(33.33% - 30px);
      a {
        text-decoration: none;
      }
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: calc(100% - 30px);
            }
          `
        );
      }}
      &:hover {
        box-shadow: 0px 3px 12px #00000029;
        transform: scale(1.05);
      }
      figure {
        border-radius: 15px;
        display: block;
        height: 0;
        margin-bottom: 20px;
        overflow: hidden;
        padding-bottom: 100%;
        position: relative;
        > div {
          position: static !important;
        }
      }
      img {
        height: 100%;
        left: 0;
        object-fit: cover;
        position: absolute;
        top: 0;
        width: 100%;
      }
      p {
        color: #263238;
        margin-bottom: calc(30px / 2);
        strong {
          color: black;
          font-size: 16px;
        }
      }
      span {
        align-items: center;
        color: #364ef7;
        display: flex;
        font-weight: bold;
        justify-content: flex-start;
        ${({ theme }) => {
          return (
            theme &&
            css`
              @media (max-width: ${theme.breakpoints.medium}) {
                font-size: 12px;
              }
            `
          );
        }}
        &:hover {
          .icon {
            transform: translateX(50%);
          }
        }
        svg {
          fill: #364ef7;
          margin-left: calc(30px / 2);
          transition: 0.3s;
          width: calc(30px / 2);
        }
      }
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
